// extracted by css-extract-rspack-plugin
export default {"footer":"footer-qhj9LN","select":"select-Knf42o"};